import React, { useEffect, useRef, useState } from 'react'
import { get } from '../../../../Model/Network/Config/Axios';
import { Modal } from '../../fModal/Modal';
import { FunctionalInput } from '../../fInputs';

function BankSelect({setBankDetails,vendor}) {
    // console.log('vendor : ',vendor);
    const [selectedBank,setSelectedBank] = useState(undefined);
    const [allBankList,setAllBankList] = useState([]);
    const [showBankList,setShowBankList] = useState(false);
    const [value,setValue] = useState(undefined);
    const BANK = useRef(null);

    useEffect(()=>{
        if(vendor && vendor.id && (vendor.key || (vendor.address && vendor.address.id))){
            setBankDetails((prev)=>({loading:true,bank:undefined}));
            let addressId = "";
            if(vendor.key){
                addressId = vendor.key;
            }
            else if(vendor.address && vendor.address.id){
                addressId = vendor.address.id;
            }
            get(`vendor/contacts/${vendor.id}/address/${addressId}/getBanks`,(e,r)=>{
                if(r && r.banks && r.banks.length){
                    setBankDetails((prev)=>({loading:false,bank:undefined}));
                    setAllBankList(r.banks);
                    for(let i=0;i<r.banks.length;i++){
                        if(r.banks[i] && r.banks[i].accountId && vendor.bankDetails && vendor.bankDetails.accountId && r.banks[i].accountId === vendor.bankDetails.accountId){
                            setSelectedBank(r.banks[i]);
                            if(r.banks[i] && r.banks[i].bankName && r.banks[i].account){
                                setValue(`${r.banks[i].bankName} || ${r.banks[i].account}`);
                            }
                            break;
                        }
                    }
                }
                else{
                    setBankDetails((prev)=>({loading:false,bank:undefined}));
                }
            })
        }
    },[vendor])

    useEffect(()=>{
        if(selectedBank && selectedBank.bankName && selectedBank.account){
            setValue(`${selectedBank.bankName} || ${selectedBank.account}`);
        }
        setBankDetails((prev)=>({
            bank:selectedBank,
            loading:false
        }));
    },[selectedBank]);

    return (
        <>
            {(allBankList.length > 0)?<FunctionalInput ref={BANK} onClick={()=>{setShowBankList(true)}} inputProps={{readOnly:true}} placeholder="Vendor Bank" title='Vendor Bank' defaultValue={value} />:null}
            {
                showBankList?<Modal 
                    title='Select Bank' 
                    des='Select bank from the list'
                    show={showBankList} 
                    hideButton={true}
                    close={()=>setShowBankList(false)}>
                    <div>
                        {
                            allBankList.map((bank)=>(
                                <div key={bank.id} onClick={()=>{setSelectedBank(bank)}} style={{marginBottom:'1rem', display:'flex', alignItems:'center'}}>
                                    <div style={{marginRight:'1rem'}}>
                                        <input type="checkbox" checked={selectedBank && selectedBank.accountId === bank.accountId} onChange={()=>{setSelectedBank(bank)}} />
                                    </div>
                                    <div>
                                        {(bank && bank.bankName)?<p style={{'fontSize':'18px', 'fontWeight':'600'}}>{bank.bankName}</p>:null}
                                        {(bank && bank.name)?<p>Account Holder Name : {bank.name}</p>:null}
                                        {(bank && bank.account)?<p>Account : {bank.account}</p>:null}
                                        {(bank && bank.branchName)?<p>Branch Name : {bank.branchName}</p>:null}
                                        {(bank && bank.ifsc)?<p>IFSC : {bank.ifsc}</p>:null}
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </Modal>:null
            }
        </>
    )
}

export default BankSelect